import { render } from "./Sidebar.vue?vue&type=template&id=677c801c"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=677c801c&lang=css"
script.render = render

export default script